<template>
  <div class="header-inner">
    <header :class="{footer}" class="header">
      <div class="border-top"></div>
      <div class="logo-container">
        <div class="logo">
          <img src="../../assets/images/logo_white.png" class="image">
          <div class="blur-item"></div>
        </div>
        <span class="mobile-title">Fortchain</span>
      </div>
      <div class="right-content">
        <ul class="menu-list">
<!--          <li @click="scrollTo('calculator')" class="list-item">Calculator</li>-->
<!--          <li @click="scrollTo('community')" class="list-item">Community</li>-->
<!--          <li @click="scrollTo('faq')" class="list-item">Faq</li>-->
        </ul>
        <registration-buttons/>
      </div>
      <div class="line"></div>
      <img v-if="footer" src="../../assets/images/vector3.png" class="footer-background" alt="">
      <burger-menu @clicked="showBurger=!showBurger"/>
    </header>
    <div v-if="!footer" :class="{active:showBurger}" class="burger-content">
      <ul class="menu-list">
        <li @click="scrollTo('calculator')" class="list-item">Calculator</li>
        <li @click="scrollTo('community')" class="list-item">Community</li>
        <li @click="scrollTo('faq')" class="list-item">Faq</li>
      </ul>
      <registration-buttons/>
    </div>
  </div>
</template>

<script>
import RegistrationButtons from './RegistrationButtons'
import BurgerMenu from "../pages/home/BurgerMenu";

export default {
  props: {
    footer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showBurger: false,
    }
  },
  components: {
    RegistrationButtons,
    BurgerMenu
  },
  methods: {
    scrollTo(id) {
      this.showBurger = false
      document.getElementById(id).scrollIntoView({
        behavior: 'smooth'
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  @include space-between;
  position: relative;
  margin: 0 auto;
  padding: 52px 8vw 30px;
  background: transparent;
  z-index: 100;
  @media only screen and (max-width: 1650px) and (min-width: 1366px) {
    padding: 42px 8vw 30px;
  }
  @media only screen and (max-width: 1365px) and (min-width: 1024px) {
    padding: 38px 5vw 20px;
  }
  @media only screen and (max-width: 1023px) {
    padding: 13px 20px 15px;
    position: fixed;
    top: 0;
    width: 100%;
    background: #070a1e;
  }

  .border-top {
    display: none;
  }

  &.footer {
    margin-top: 200px;
    padding: 52px 8vw 82px;
    background: black;
    z-index: 1;
    @media only screen and (max-width: 1366px) and (min-width: 1024px) {
      padding: 38px 5vw 62px;
    }
    @media only screen and (max-width: 1023px) {
      padding: 22px 20px 35px;
      margin-top: 35px;
      position: relative;
    }

    .border-top {
      display: block;
      background: white;
      height: 0.5px;
      width: 84vw;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      @media only screen and (max-width: 1366px) and (min-width: 1024px) {
        width: 90vw;
      }
      @media only screen and (max-width: 1023px) {
        width: calc(100% - 40px);
      }
    }

    .line {
      display: none;
    }

    .footer-background {
      position: absolute;
      pointer-events: none;
      right: 0;
      bottom: 0;
    }

    .burger-menu {
      display: none;
    }
  }

  .logo-container {
    @include flex;

    .mobile-title {
      display: none;
      color: white;
      margin-left: 15px;
      font-size: 24px;
      @media only screen and (max-width: 1023px) {
        display: block;
      }
    }
  }

  .logo {
    @include center-children;
    position: relative;
    height: 105px;
    width: 105px;
    border-radius: 50%;
    border: 5px solid #1280A0;
    padding: 15px;
    cursor: pointer;
    @media only screen and (max-width: 1650px) and (min-width: 1366px) {
      height: 80px;
      width: 80px;
    }
    @media only screen and (max-width: 1365px) and (min-width: 1024px) {
      height: 65px;
      width: 65px;
      padding: 10px;
      border: 3px solid #1280A0;
    }
    @media only screen and (max-width: 1023px) {
      height: 60px;
      width: 60px;
      padding: 10px;
      border: 3px solid #1280A0;
    }

    .blur-item {
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgba(66, 232, 224, 0.4);
      filter: blur(50px);
      border-radius: 50%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      pointer-events: none;
    }

    img {
      height: 100%;
      object-fit: contain;
      max-width: unset;
      font-style: unset;
      vertical-align: unset;
      image-rendering: -webkit-optimize-contrast;
    }
  }

  .right-content {
    @include center-children;
    @media only screen and (max-width: 1023px) {
      display: none;
    }

    .menu-list {
      padding-inline-start: 0;
      list-style-type: none;
      padding: 0 51px 0;
      margin-bottom: 0;
      @include flex;

      .list-item {
        color: white;
        margin-right: 32px;
        cursor: pointer;
        text-transform: capitalize;
        font-size: 18px;
        @media only screen and (max-width: 1366px) and (min-width: 1024px) {
          margin-right: 16px;
          font-size: 16px;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .line {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    background: white;
    width: 84vw;
    height: 1px;
    @media only screen and (max-width: 1366px) and (min-width: 1024px) {
      width: 90vw;
    }
    @media only screen and (max-width: 1023px) {
      width: calc(100% - 40px);
    }
  }
}

::v-deep .burger-content {
  @include center-children;
  flex-direction: column;
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  background: #070a1e;
  z-index: 99;
  opacity: 0;
  pointer-events: none;
  transition: all .4s ease-out;

  &.active {
    opacity: 1;
    pointer-events: auto;
  }

  .menu-list {
    padding-inline-start: 0;
    list-style-type: none;
    padding: 0 51px 0;
    margin-bottom: 0;

    .list-item {
      color: white;
      cursor: pointer;
      text-transform: capitalize;
      font-size: 28px;
      margin-top: 15px;
      text-align: center;
    }
  }

  .registration-button {
    flex-direction: column-reverse;
    margin-top: 30px;

    .sign-in.button {
      margin-left: 0;
      margin-bottom: 15px;
    }
  }
}
</style>